/**
 * Базовый класс ошибок, обеспечивающий корректное отображение названия класса ошибки-наследника в консоли.
 */
export class CustomError extends Error {
  constructor(...args: ConstructorParameters<typeof Error>) {
    super(...args);
    this.name = this.constructor.name;
  }
}
